import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Props } from "framer-motion/types/types";
import socket from "../../../utilities/socket";
import Peer from "peerjs";
import VideoComponent from "../../layout/VideoComponent";
import { Flex } from "@chakra-ui/layout";
import NavBar from "../../layout/NavBar";
import { useSelector } from "react-redux";
import { StateType } from "../../../store/store";
import Swal from "sweetalert2";
import Controls from './Controls';
import Facilities from './Facilities';
import { DestDetails, mediaState, metaData, userType } from '../../../interfaces/interfaces';

function Class({ match }: Props) {
  const { teacherReducer: { data: { username, role } }, studentReducer } = useSelector((state: StateType) => state.rootReducer);
  const userRole = studentReducer.data.role !== "" ? "student" : "tutor";
  const name = username !== "" ? username : studentReducer.data.username;

  const [userStream, setStream] = useState<MediaStream>(new MediaStream);
  const [participantStream, setParticipantStream] = useState<mediaState>({ caller: new MediaStream, receiver: new MediaStream });
  const [aCall, setCall] = useState<Peer.MediaConnection>();
  const [screenCall, setScreenCall] = useState<Peer.MediaConnection>()
  const [getPeerId, setPeerId] = useState<string>("");
  const [myPeerId, setMyPeerId] = useState<string>("");
  const [callerVideo, setCallerVideo] = useState<userType>({ teacher: [], student: [] });
  const [participantVideo, setParticipantVideo] = useState<userType & { sharing: JSX.Element[] }>({ teacher: [], student: [], sharing: [] });
  const [participantReceiverVideo, setParticipantReceiverVideo] = useState<userType>({ teacher: [], student: [] });
  const [callData, setCallData] = useState<metaData>({ caller: "", receiver: "" });
  const [destDetails, setDestDetails] = useState<DestDetails>({ caller: { peerId: "", socketId: "" }, receiver: { peerId: "", socketId: "" } });
  const [sharingStatus, setSharingStatus] = useState<boolean>(false);
  const [shareStream, setShareStream] = useState<MediaStream>(new MediaStream);
  const [sharing, setSharing] = useState<JSX.Element>();

  const _class = match.params.class;
  const peers: any = {}
  socket.connect();

  const peer = new Peer();

  // I call the new user
  function connectToNewUser(userId: string, stream: MediaStream, socketId: string) {
    console.log("new user", userId, socketId);
    setDestDetails(prevState => ({
      ...prevState,
      receiver: {
        peerId: userId,
        socketId
      }
    }))
    console.log(peer.id)
    setPeerId(userId)
    const roleName = studentReducer.data.role === "" ? role : studentReducer.data.role;
    console.log(roleName)
    console.log(socket.id)
    const call = peer.call(userId, stream, { metadata: roleName });
    call.on('stream', (stream) => {
      // the receiver
      // need to know if the person we're calling is a teacher or student
      console.log(call.metadata, "from peer.call");
      console.log(call.peer)
      setParticipantStream(prevState => ({ ...prevState, receiver: stream }));
      setCallData(prevState => ({ ...prevState, receiver: call.metadata }));
      call.on('close', () => {
        console.log(peer.id)
        console.log(call.peer)
        console.log("closed")
      })
      if (peer.destroyed) {
        call.close()
      }
    })
    call.on("close", () => {
      setParticipantReceiverVideo(prevState => ({
        teacher: prevState.teacher.filter(({ props }) => {
          props["data-peerid"] !== peer.id
        }),
        student: prevState.teacher.filter(({ props }) => {
          props["data-peerid"] !== peer.id
        })
      }))
      setParticipantVideo(prevState => ({
        ...prevState,
        teacher: prevState.teacher.filter(({ props }) => {
          props["data-peerid"] !== peer.id
        }),
        student: prevState.teacher.filter(({ props }) => {
          props["data-peerid"] !== peer.id
        })
      }))
      console.log("closed")
    })
    peers["usersId"] = call;
    console.log(peers)
  }

  useEffect(() => {
    socket.on("user-disconnected", (userId) => {
      console.log(userId)
      setParticipantReceiverVideo(prevState => ({
        teacher: prevState.teacher.filter(({ props }) => {
          props["data-peerid"] !== peer.id
        }),
        student: prevState.teacher.filter(({ props }) => {
          props["data-peerid"] !== peer.id
        })
      }))
      setParticipantVideo(prevState => ({
        ...prevState,
        teacher: prevState.teacher.filter(({ props }) => {
          props["data-peerid"] !== peer.id
        }),
        student: prevState.teacher.filter(({ props }) => {
          props["data-peerid"] !== peer.id
        })
      }))
      if (peers["usersId"]) return peers["usersId"].close()
    })
  }, [peers["usersId"]])

  const userVideo = useCallback((node: HTMLVideoElement) => {
    if (node !== null && userStream.active !== false) {
      node.srcObject = userStream;
    }
  }, [userStream])

  useEffect(() => {
    if (userStream.active !== false) {
      const roleName = studentReducer.data.role === "" ? role : studentReducer.data.role;
      let video = (<video ref={userVideo} id={`${socket.id} ${myPeerId}`} className={`${roleName === "teacher" ? "main__video" : "other__videos"}`} playsInline autoPlay />)
      roleName === "teacher" ?
        setCallerVideo(prevState => ({
          ...prevState,
          teacher: [...prevState.teacher, video]
        })) :
        setCallerVideo(prevState => ({
          ...prevState,
          student: [...prevState.student, video]
        }))
    }
  }, [userVideo])

  const caller = useCallback((node: HTMLVideoElement) => {
    if (node !== null && participantStream.caller.active !== false && callData.caller !== "") {
      node.srcObject = participantStream.caller;
    }
  }, [participantStream.caller, callData.caller, destDetails.caller])

  useEffect(() => {
    if (participantStream.caller.active !== false && callData.caller !== "") {
      let video = (<video ref={caller} id={`${callData.caller === "sharedScreen" ? "sharingId" : "other"}`} data-peerid={destDetails.caller.peerId} data-socketid={destDetails.caller.socketId} className={`${callData.caller === "teacher" ? "main__video" : callData.caller === "sharedScreen" ? "main__video" : "other__videos"}`} playsInline autoPlay />)
      console.log(callData.caller)
      console.log(sharingStatus)
      callData.caller === "teacher" ?
        setParticipantVideo(prevState => ({
          ...prevState,
          teacher: [...new Set<JSX.Element>([...prevState.teacher, video])]
        })) :
        setParticipantVideo(prevState => ({
          ...prevState,
          student: [...prevState.student, video]
        }))
    }
  }, [caller])

  const receiver = useCallback((node: HTMLVideoElement) => {
    if (node !== null && participantStream.receiver.active !== false && callData.receiver !== "") {
      node.srcObject = participantStream.receiver;
    }
  }, [participantStream.receiver, callData.receiver, destDetails.receiver])

  useEffect(() => {
    if (participantStream.receiver.active !== false && callData.receiver !== "") {
      let video = (<video ref={receiver} id={`${socket.id} ${peer.id}`} data-peerid={destDetails.receiver.peerId} data-socketid={destDetails.receiver.socketId}
        className={`${(callData.receiver === "teacher" && userRole === "tutor") || (callData.receiver === "student" && userRole === "student") ? "other__videos" : "main__video"}`}
        playsInline autoPlay
      />);
      console.log(callData.receiver);
      (callData.receiver === "teacher" && userRole === "tutor") || (callData.receiver === "student" && userRole === "student") ?
        setParticipantReceiverVideo(prevState => ({
          ...prevState,
          student: [...prevState.student, video]
        })) :
        setParticipantReceiverVideo(prevState => ({
          ...prevState,
          teacher: [...prevState.teacher, video]
        }))
    }
  }, [receiver])

  useEffect(() => {
    peer.on('open', (id) => {
      console.log(id);
      setMyPeerId(id)
      socket.emit("join-room", _class, id, { id: socket.id, userName: name, role: userRole, room: _class });
    })
    const constraints: MediaStreamConstraints = {
      audio: {
        echoCancellation: true,
        noiseSuppression: true
      },
      peerIdentity: peer.id,
      video: {
        facingMode: "user",
        echoCancellation: true,
        noiseSuppression: true
      }
    };
    peer.on("disconnected", () => {
      console.log("disconnected")
    })
    peer.on("error", (err) => {
      console.log(err + err.type);
      Swal.fire({
        icon: "error",
        text: err + err.type
      }).then(r => r)
    })

    navigator.mediaDevices.getUserMedia(constraints)
      .then((mediaStream) => {
        setStream(mediaStream);

        peer.on("call", (call) => {
          call.answer(mediaStream); // Answer the call, providing our mediaStream
          setCall(call)
          console.log(call.metadata) // the person calling us, so I can get info from here
          console.log(call.peer)
          console.log(socket.id)
          // add the socket.id to setdestDetails but leave peerId unchanged
          setDestDetails(prevState => ({
            ...prevState,
            caller: {
              peerId: call.peer,
              socketId: prevState.caller.socketId
            }
          }))
          call.on('stream', (userVideosStream) => {
            setParticipantStream(prevState => ({ ...prevState, caller: userVideosStream }));
            setCallData(prevState => ({ ...prevState, caller: call.metadata }));
          });
          if (peer.destroyed) {
            call.close()
          }
          call.on('close', () => {
            console.log("closed");
            if (peers["usersId"]) return peers["usersId"].close()
          })
        })
        peer.on("close", () => {
          console.log("closed");
          if (peers["usersId"]) return peers["usersId"].close();
        })
        socket.on("user-connected", (userId, socketId) => {
          connectToNewUser(userId, mediaStream, socketId);
        })
      })
      .catch(function (err) {
        console.log(err.name + ": " + err.message);
        Swal.fire({
          icon: "error",
          text: err.message
        }).then(r => r)
      });
  }, []);

  const sharingVideo = useCallback((node: HTMLVideoElement) => {
    if (node !== null && shareStream.active !== false) {
      node.srcObject = shareStream;
    }
  }, [shareStream])

  useEffect(() => {
    if (shareStream.active !== false) {
      let video = (<video ref={sharingVideo} id={"sharingId"} className="main__video" playsInline autoPlay />)
      setSharing(video)
    }
  }, [sharingVideo])

  async function shareScreen() {
    const constraints = {
      video: {
        cursor: "always"
      },
      audio: {
        echoCancellation: true,
        noiseSuppression: true,
        sampleRate: 44100
      }
    }
    let captureStream: MediaStream;
    if (!sharingStatus) {
      try {
        // @ts-ignore
        captureStream = await navigator.mediaDevices.getDisplayMedia(constraints);
        setShareStream(captureStream);
        setSharingStatus(true);
        // const call = peer.call(getPeerId, captureStream as MediaStream, { metadata: "sharedScreen" });
        // call.on('close', () => {
        //   console.log("closed")
        // })
        // setScreenCall(call)
      } catch (err) {
        console.error("Error: " + err);
        await Swal.fire({
          icon: 'error',
          text: err
        })
      }
      return;
    }
    if (sharingStatus) {
      // @ts-ignore
      // remove video
      // screenCall!.close();
      setSharing(undefined);
      setSharingStatus(false);
      console.log(sharingStatus)
    }
  }

  return (
    <>
      <NavBar role={userRole} />
      <Flex flexDirection={{ base: "column", md: "row" }} w={"100%"} px={{ base: 2, lg: 8 }} my={3} minH={"100vh"}>
        <VideoComponent peerId={peer.id} callerVideo={callerVideo} participantVideo={participantVideo}
          participantReceiverVideo={participantReceiverVideo} sharing={sharing}
        />
      </Flex>
      <Facilities roomName={_class} />
      <Controls peers={peers} peer={peer} aCall={aCall} userStream={userStream} getPeerId={getPeerId}
        _class={_class} sharingStatus={sharingStatus} shareScreen={shareScreen} participantVideo={participantVideo}
        participantReceiverVideo={participantReceiverVideo} setParticipantVideo={setParticipantVideo}
        setParticipantReceiverVideo={setParticipantReceiverVideo}
      />
    </>
  );
}

export default Class;